if (!customElements.get('upsell-add')) {
  class UpsellAdd extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
      this.handleUpsellVariantChangeRef = this.handleUpsellVariantChange.bind(this);
    }

    handleClick(event) {
      if (!this.button) return;

      event.preventDefault();
      const eventType = 'alexa:upsell-add';

      this.addedVariants.push(this.getAttribute('data-variant-id'));

      document.dispatchEvent(
        new CustomEvent(eventType, {
          detail: {
            item: {
              id: this.getAttribute('data-variant-id'),
              quantity: 1,
              properties: {
                _AddonToProduct: this.getAttribute('data-add-with-product'),
                _MainProduct: this.getAttribute('data-product-id')
              },
            },
          },
        })
      );
    }

    setButtonAddedTitle() {
      this.button.innerHTML = this.button.getAttribute('data-added');
    }

    setButtonUnavailableTitle() {
      this.button.innerHTML = this.button.getAttribute('data-unavailable');
    }

    updateButtonTitle(variantAdded, title) {
      if (variantAdded) return this.setButtonAddedTitle();
      if (this.button.disabled) return this.setButtonUnavailableTitle();
      if (this.button.hasAttribute('data-active')) return this.setButtonAddedTitle();

      this.button.innerHTML = this.button.getAttribute('data-title-text').replace('[[title]]', title);
    }

    updateButtonState(force, variantAdded) {
      this.button.toggleAttribute('disabled', force);
      this.button.toggleAttribute('data-active', variantAdded);
    }

    updateButton(input, title) {
      const variantAdded = this.addedVariants.includes(input.value);

      this.updateButtonState(input.hasAttribute('data-unavailable'), variantAdded);
      this.updateButtonTitle(variantAdded, title);
    }

    setCurrentVariantId(input) {
      this.setAttribute('data-variant-id', input.value);
    }

    handleUpsellVariantChange(event) {
      const { input, title, productId } = event.detail;
      if (productId != this.getAttribute('data-product-id')) return;

      this.updateButton(input, title);
      this.setCurrentVariantId(input);
    }

    disconnectedCallback() {
      if (!this.button) return;

      this.removeEventListener('click', this.handleClickRef);
      document.removeEventListener('alexa:upsell-variant-change', this.handleUpsellVariantChangeRef);
    }

    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;

      this.addedVariants = [];

      this.addEventListener('click', this.handleClickRef);
      document.addEventListener('alexa:upsell-variant-change', this.handleUpsellVariantChangeRef);
    }
  }

  customElements.define('upsell-add', UpsellAdd);
}
